// Mapa de qué anchor de changelog.js corresponde a qué estado interno en
// cada capa anidada del panel (diálogo de pantalla completa > tab >
// sub-vista). Vive separado de changelog.js a propósito: ese archivo es
// contenido (lo que se le muestra al usuario/chatbot), este es cableado de
// UI — así agregar una entrada al changelog nunca obliga a tocar esto, y
// viceversa.
//
// Cobertura actual: los anchors que viven dentro de "Inscripciones" →
// "Configuración"/"Autorizaciones" (RegistryContainerUI). Los anchors de
// Cronometraje y Reportes (cronometraje-*, reportes-*) todavía NO están
// aquí — su anidamiento de diálogos/tabs no se verificó a este nivel de
// detalle. Para esos, el tooltip debe mostrar la información igual pero sin
// botón de "ir a la función" (ver DEEP_LINK_READY_ANCHORS).

const INSCRIPCIONES_ANCHORS = new Set([
  "tab-dorsal",
  "tab-etiquetas",
  "tab-correos-campana",
  "tab-edicion-masiva",
  "tab-deslinde",
  "tab-inventarios",
  "tab-autorizaciones-importar",
  "tab-autorizaciones-logs",
]);

export const DEEP_LINK_READY_ANCHORS = INSCRIPCIONES_ANCHORS;

export function anchorAbreInscripciones(anchor) {
  return !!anchor && INSCRIPCIONES_ANCHORS.has(anchor);
}

// Dentro de RegistryContainerUI.jsx: a qué tab (su "key" real en arrayTabs)
// pertenece cada anchor.
const REGISTRY_UI_TAB_POR_ANCHOR = {
  "tab-autorizaciones-importar": "tab-Autorizaciones",
  "tab-autorizaciones-logs": "tab-Autorizaciones",
  "tab-dorsal": "tab-Configuracion",
  "tab-etiquetas": "tab-Configuracion",
  "tab-correos-campana": "tab-Configuracion",
  "tab-edicion-masiva": "tab-Configuracion",
  "tab-deslinde": "tab-Configuracion",
  "tab-inventarios": "tab-Configuracion",
};

export function registryUiTabKeyPara(anchor) {
  return REGISTRY_UI_TAB_POR_ANCHOR[anchor] || null;
}

// Dentro de RegistryConfigurationContainer.jsx: a qué tab (su "key" real)
// pertenece cada anchor. "tab-correos-campana" apunta al tab que ya existe
// con key "tab-correos" (la campaña vive como un botón dentro de ese tab,
// no como tab propio — el deep-link llega hasta el tab, no hasta el botón).
const CONFIG_CONTAINER_TAB_POR_ANCHOR = {
  "tab-dorsal": "tab-dorsal",
  "tab-etiquetas": "tab-etiquetas",
  "tab-correos-campana": "tab-correos",
  "tab-edicion-masiva": "tab-edicion-masiva",
  "tab-deslinde": "tab-deslinde",
  "tab-inventarios": "tab-inventarios",
};

export function configContainerTabKeyPara(anchor) {
  return CONFIG_CONTAINER_TAB_POR_ANCHOR[anchor] || null;
}

// Dentro de RegistryAuthorizationContainer.jsx: a qué "vistaReporte"
// corresponde el anchor. Solo "logs" tiene una vista alterna hoy; el
// importador de Excel se abre con un botón propio dentro de la vista
// "atletas" (default), así que no necesita mapeo.
const VISTA_REPORTE_POR_ANCHOR = {
  "tab-autorizaciones-logs": "logs",
};

export function vistaReportePara(anchor) {
  return VISTA_REPORTE_POR_ANCHOR[anchor] || null;
}
